import React from "react";
import styled from "styled-components";
import * as vars from "../style/vars";
import { above, below } from "../style/functions";

const Jumbotron = ({title, description}) => {
  return (
    <JumbotronWrapper>
      <h1 dangerouslySetInnerHTML={{ __html: title }} />
      <p
        dangerouslySetInnerHTML={{
          __html: description
        }}
      />
    </JumbotronWrapper>
  );
};

const JumbotronWrapper = styled.div`
  & {
    padding-top: ${vars.padding.inner * 5}rem;
    padding-bottom: ${vars.padding.inner * 1}rem;
		${below.l`
			padding-top: ${vars.padding.outer / 2}rem;
		`}
  }
	h1 {
		max-width: 120rem;
	}
	p {
		max-width: 55rem;
	}
   ${below.tablet`
      padding-top: ${vars.padding.inner * 3}rem;
      `}
   ${below.mobile`
      padding-top: ${vars.padding.inner * 1.5}rem;
      padding-bottom: ${vars.padding.inner / 2}rem;
      & > p {
      display: none;
      }
   `};
`;

export default Jumbotron;



// WEBPACK FOOTER //
// ./src/components/jumbotron.js